import { AccountLookupService } from "../lookup/model/impl/AccountLookupService";
import { AccountModelPrivatization } from "./privatization/AccountModelPrivatization";
import { AlgoStrategyLookupService } from "../lookup/model/impl/AlgoStrategyLookupService";
import { AtdlTooltipUiRep } from "./adtl/atdl-tooltip-ui-rep";
import { CcyLookupService } from "../lookup/model/impl/CcyLookupService";
import { CcyPairLookupService } from "../lookup/model/impl/CcyPairLookupService";
import { ClientLookupService } from "../lookup/model/impl/ClientLookupService";
import { ClientModelPrivatization } from "./privatization/ClientModelPrivatization";
import { ClientTraderModelPrivatization } from "./privatization/ClientTraderModelPrivatization";
import { CustomFieldLookupService } from "../lookup/model/impl/CustomFieldLookupService";
import { ExtendedTradeTableDefinitionFactory } from "./ExtendedTradeTableDefinitionFactory";
import { RISK_TRADE_TABLE_DEFINITION_VER } from "./TableDefinitionFactory.constants";
import { Injectable } from "@angular/core";
import { Optional } from "ag-grid-community";
import { ProfilePromiseActionService } from "../profile/impl/ProfilePromiseActionService";
import { SalesGroupLookupService } from "../lookup/model/impl/SalesGroupLookupService";
import {
  SystemConfigPromiseService,
  BfxSysConfigUtilService,
  BfxConfigService,
} from "../../auth-services";
import { TraderGroupLookupService } from "../lookup/model/impl/TraderGroupLookupService";
import { TranslateService } from "@ngx-translate/core";
import { UserLookupService } from "../lookup/model/impl/UserLookupService";
import { BlotterType } from "shared/cubiq-model-multi-asset";
import { TableDefinition } from "./TableDefinition";

@Injectable()
export class RiskTradeTableDefinitionFactory extends ExtendedTradeTableDefinitionFactory {
  constructor(
    profileService: ProfilePromiseActionService,
    protected atdlTooltipUiRep: AtdlTooltipUiRep,
    // It is not possible to inject against an interface
    @Optional() _ccyLookupService: CcyLookupService,
    @Optional() _ccyPairLookupService: CcyPairLookupService,
    @Optional() _clientLookup: ClientLookupService,
    @Optional() _accountLookup: AccountLookupService,
    @Optional() _salesGroupLookup: SalesGroupLookupService,
    @Optional() _traderGroupLookup: TraderGroupLookupService,
    @Optional() _userLookup: UserLookupService,
    @Optional() _sysConfigService: SystemConfigPromiseService,
    @Optional() _translateService: TranslateService,
    @Optional() algoStrategyLookupService: AlgoStrategyLookupService,
    @Optional() cmp: ClientModelPrivatization,
    @Optional() amp: AccountModelPrivatization,
    @Optional() ctmp: ClientTraderModelPrivatization,
    @Optional() sysConfigUtil: BfxSysConfigUtilService,
    @Optional() configService: BfxConfigService,
    @Optional() customFieldLookupService: CustomFieldLookupService,
  ) {
    super(
      profileService,
      atdlTooltipUiRep,
      _ccyLookupService,
      _ccyPairLookupService,
      _clientLookup,
      _accountLookup,
      _salesGroupLookup,
      _traderGroupLookup,
      _userLookup,
      _sysConfigService,
      _translateService,
      algoStrategyLookupService,
      cmp,
      amp,
      ctmp,
      sysConfigUtil,
      configService,
      customFieldLookupService,
    );

    this.statusIconHelper.ignoreSTPDisabledIcons = true;
  }

  public createDef(): TableDefinition {
    let td = super.createDef();
    td.riskTradeTableDefinition = true;
    return td;
  }

  public getVersionIdentifier(): string {
    return RISK_TRADE_TABLE_DEFINITION_VER;
  }

  public getBlotterType(): BlotterType {
    return BlotterType.RISKTRADE;
  }
}
